export default "__VITE_ASSET__D4GRa_OM__"